// extracted by mini-css-extract-plugin
export default {"rowOfDraggableList":"rowOfDraggableList---JUh8L"};